module.exports = __webpack_public_path__ + "img/file-earmark-diff-fill.043bd4ef.svg";